// extracted by mini-css-extract-plugin
export default {"pageHeader":"C6fT5tQXiKOTTLSg8s5i","cookiesContent":"NU1SwvIl1iFVjiomq8FH","cookiesList":"n3WslUjpE4WxzzkzCR3X"};